export default "__VITE_ASSET__DUmlm9wK__"